'use strict';

var _ = require('lodash');
function FlightManagementSearchCriteriaTransformationsService() {
  function transformLegFieldsToSegFields(rules) {
    var mapLegFieldsToSegFields = {
      'custom:leg': 'custom:segment',
      'legs.origin': 'segments.origin',
      'legs.destination': 'segments.destination'
    };
    return _.transform(rules, function (transformedRules, rule) {
      if (mapLegFieldsToSegFields[rule.field]) {
        var clonedCriteria = _.cloneDeep(rule);
        clonedCriteria.field = mapLegFieldsToSegFields[clonedCriteria.field];
        transformedRules.push(clonedCriteria);
      }
      return transformedRules;
    }, []);
  }
  return {
    transformLegFieldsToSegFields: transformLegFieldsToSegFields
  };
}
FlightManagementSearchCriteriaTransformationsService.$inject = [];
module.exports = FlightManagementSearchCriteriaTransformationsService;